import SplunkOtelWeb from '@splunk/otel-web';
import { getSplunkAppConfigData } from './utils/request';

export const getAppConfig = () =>
  getSplunkAppConfigData()
    .then(response => {
      const {
        data: { smso_rum_token, splunk_env }
      } = response;
      SplunkOtelWeb.init({
        beaconUrl: 'https://rum-ingest.us1.signalfx.com/v1/rum',
        rumAuth: smso_rum_token,
        app: 'print_hpsmart_rum',
        environment: splunk_env
      });
      return { smso_rum_token, splunk_env };
    })
    .catch(err => {
      console.log(err);
      return true;
    });
